import React from 'react';
import cx from 'classnames';
import './Anchor.scss';

const Anchor = (props) => {
  const { text, className, isUnderLine = false, color, ...res } = props;

  return (
    <a className={cx('anchor', className, color, { isUnderLine })} {...res}>
      {text}
    </a>
  );
};

export default Anchor;
